// features/termination-request/presentation/routes/terminationRequestRoute.ts
import type { RouteLocationNormalized, Router } from "vue-router";

export const terminationRequestRouteName = {
  index: "termination-requests.index",
  show: "termination-requests.show",
};

export const terminationRequestRoute = [
  {
    path: "/termination-requests",
    name: terminationRequestRouteName.index,
    component: () => import("../pages/DataTablePage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "termination_request",
      breadcrumbs: () => {
        return [{ title: "Termination Request" }];
      },
    },
  },
  {
    path: "/termination-requests/:id",
    name: terminationRequestRouteName.show,
    component: () => import("../pages/DetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "termination_request",
      breadcrumbs: (_to: RouteLocationNormalized, router: Router) => {
        return [{ path: router.resolve({ name: terminationRequestRouteName.index }).path, title: "Termination Request" }, { title: "Detail" }];
      },
    },
  },
];
